<template>
  <div class="tabs">
    <div class="tab">
      <div class="tab-headers">
        <span
          v-for="(tab,i) in tabs"
          :key="i"
          :class="{
            'tabitem': customclass,
            'header-item': true,
            'selected': (i==active_selected_index)
            }"
            @click="active_selected_index = i; $emit('changeTab',i)"
           >
           {{tab.header}}
           <span
            v-if="showcount && i == active_selected_index"
            class="count">
              {{tab.count}}
            </span>
        </span>
      </div>
      <div class="icon">
        <slot name="icon"></slot>
      </div>
      <div class="logout-icon">
        <slot name="logout-icon"></slot>
      </div>
      <div class="upload-btn">
        <slot name="upload"></slot>
      </div>
    </div>
    <div class="tab-container" ref="tabContainer">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {},
    selected: { type: Number, default: 0 },
    customclass: {type: Boolean, default: false},
    showcount: {type: Boolean, default: false}
  },
  data() {
    return {
      local_active_selected_index: this.selected
    };
  },
  computed: {
    active_selected_index: {
      get() {
        return this.local_active_selected_index;
      },
      set: function(value) {
        this.local_active_selected_index = value;
        this.updateSelectedTabClass();
        this.$emit("selectedTabChanged", value);
        //console.log('selected',this.selected);
      }
    },
  
    selectedComponent: {
      get() {
        return this.tabs[this.selected].component;
      }
    }
  },
  methods: {
    updateSelectedTabClass() {
 //     debugger
      let tabContainer = this.$refs.tabContainer;
      for (let ci = 0; ci < tabContainer.childNodes.length; ci++) {
        tabContainer.childNodes[ci].classList.remove("selected");
        if (ci == this.active_selected_index) {
          tabContainer.childNodes[ci].classList.add("selected");
        }
      }
    }
  },
  mounted() {
    this.updateSelectedTabClass();
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

@keyframes selectedTab {
  from {
    font-weight: normal;
    border-bottom: 2px solid transparent;
  }
  to {
    font-weight: 500;
    border-bottom: 2px solid $color-secondary;
  }
}

$tab-padding: 16px;
.tabs {
  width: 100%;
  .tab{
    display: flex;
    .icon {
      margin-top: 5px;
    }
  }
  .tab-headers {
    display: block;
    min-height: $tab-padding;
    flex-grow: 1;    border-bottom: 2px solid $color-secondary;

    .header-item {
      display: inline-block;
      color: $color-primary;
      font-size: 16px;
      padding-bottom: 8px;
      padding-left: 2px;
      padding-right: 2px;
      margin-right: 32px;
      cursor: pointer;
      border-bottom: 2px solid transparent;

      &.selected {
        font-weight: 600;
        border-bottom: 2px solid $color-secondary;
        animation-name: selectedTab;
        animation-duration: 0.3s;
        animation-timing-function: ease-in-out;
      }
      .count{
          background-color: #f2f3f3;
          padding: 2px 7px 2px 7px;
          border-radius: 5px;
        }
    }
    .tabitem{
      color: #646464;
      font-size: 14px;
       &.selected {
         color: $color-primary;
       }
    }
  }

  .tab-container {
    padding-top: 24px;
    padding-left: 16px;

    .tl-tab.selected {
      display: block;
    }
  }
  .upload-btn button{
    border: 1px solid #5d409f;
    font-size: 12px;
    /* padding: 3px; */
    width: 70px;
    height: 25px;
    color: #5d409f;
    border-radius: 4px;
  }
  .logout-icon img{
    margin : 0px 5px;
    height: 25px;
  }
}
</style>
